import styled from 'styled-components'

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.feedback.action.default};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.size.border.radius['02']};
  }
`
